<template>
    <div class="modal__container">
        <div v-if="isSelectTime" class="modal__time">
            <div class="modal__time_header">
                <div class="modal__time_header_close cursor_pointer" @click.prevent="closeModal">
                    <svg height="24" width="24">
                        <use xlink:href="/icons/base.svg#close"></use>
                    </svg>
                </div>
                <div class="modal__time_header_text">
                    {{ __t('O.CHOOSE_HOW_MUCH_TIME_YOU_NEED') }}
                </div>
                <div class="modal__time_header_text">
                    {{ __t('O.TO_FULFILL_THIS_ORDER') }}
                </div>
            </div>
            <modal_time_list
                :key="'modal_time_list'"
                :chunkArray="chunkArrayTime"
            />
            <div class="modal__time_buttons">
                <button class="modal__time_buttons_button" @click.prevent="clickChangeTime">
                    <div class="modal__time_buttons_button_text">
                        {{ __t('O.CHANGE_THE_TIME') }}
                    </div>
                </button>
            </div>
        </div>
        <div v-show="!isSelectTime" class="modal__new_order">
            <div class="modal__new_order_container">
                <div ref="svgContainer" class="modal__new_order_logo">
                </div>
                <div class="modal__new_order_text">
                    <div class="modal__new_order_text_info">
                        {{ __t('O.ORDER_ACCEPTED') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {arrayFunctions} from "../../../mixins/arrayFunctions";
import modal_time_list from "./ModalTimeList.vue";
import insertSvg from "../../../mixins/insertSvg";
import {createHelpers} from "vuex-map-fields";
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "modal_time",
    props: {
        arrayTime: {
            type: Array,
            required: true,
        },
        actionButton: {
            type: Object,
            required: true,
        }
    },
    emits: ['close_modal_time', 'click_change_time'],
    components: {
        modal_time_list,
    },
    mixins: [arrayFunctions, insertSvg],
    data() {
        return {
            timeSelect: {},
            timeValue: null,
            chunkArrayTime: [],
            arrayTimeInit: [
                {time: 1, isSelect: false},
                {time: 5, isSelect: false},
                {time: 10, isSelect: true},
                {time: 15, isSelect: false},
                {time: 20, isSelect: false},
                {time: 25, isSelect: false},
                {time: 30, isSelect: false},
                {time: 40, isSelect: false},
                {time: 50, isSelect: false},
                {time: 60, isSelect: false},
            ],
            isSelectTime: true,
        }
    },
    created() {
        this.initData();
        EventBus.$on('click_time', this.clickTime)
    },
    mounted() {
        if (this.activeItemMenuOrders && this.activeItemMenuOrders.aggregator && this.activeItemMenuOrders.aggregator.icon) {
            this.insertSvg(this.activeItemMenuOrders.aggregator.icon);
        }
    },
    beforeUnmount() {
        EventBus.$off('click_time', this.clickTime)
    },
    methods: {
        initData() {
            this.timeSelect = this.arrayTime[2];
            this.timeValue = this.timeSelect.time;
            this.chunkArrayTime = this.chunkArray(this.arrayTime, 5);
        },
        closeModal() {
            EventBus.$emit('close_modal_time');
        },
        clickTime(timeObject) {
            timeObject.isSelect = true;
            this.timeValue = timeObject.time;
            this.arrayTime.forEach(item => item.isSelect = item === timeObject);
        },
        clickChangeTime() {
            this.isSelectTime = false;
            setTimeout(() => {
                EventBus.$emit('change_modal_time', {itemButton: this.actionButton, timeSelect: this.timeValue});
                this.closeModal();
            }, 1000);


        }
    },
    computed: {
        ...mOrders([
            'activeItemMenuOrders',
        ]),
    },
    watch: {}
}
</script>
